import { __rest } from 'tslib';
import React from 'react';
import { useTheme } from '@10d/tend-ui-theme';
import { Root } from './styled.js';

const NavigationItem = (_a) => {
    var { children, borderRadius } = _a, props = __rest(_a, ["children", "borderRadius"]);
    const theme = useTheme();
    return (React.createElement(Root, Object.assign({}, props, { theme: theme, className: 'tend-ui-stack-navigation-item-root', "$borderRadius": borderRadius }), children));
};

export { NavigationItem };
